module.exports = __webpack_public_path__ + "img/MA.96c64127.png";